export const ERROR_QUOTES_ALL_PROVIDERS_FAILED = {
  code: 'ERROR_QUOTES_ALL_PROVIDERS_FAILED',
  message: 'Failed to fetch quotes from all providers',
}

export const ERROR_ASSETS_ALL_PROVIDERS_FAILED = {
  code: 'ERROR_ASSETS_ALL_PROVIDERS_FAILED',
  message: 'Failed to fetch assets from all providers',
}

export const ERROR_COUNTRIES_ALL_PROVIDERS_FAILED = {
  code: 'ERROR_COUNTRIES_ALL_PROVIDERS_FAILED',
  message: 'Failed to fetch countries from providers',
}

export const ERROR_PAYMENT_METHOD_NOT_SUPPORTED = {
  code: 'ERROR_PAYMENT_METHOD_NOT_SUPPORTED',
  message: 'Payment method is not supported',
}

class AggregateError_ extends Error {
  constructor(errors, message) {
    super(message)
    this.name = 'AggregateError'
    this.errors = errors
  }
}

export const AggregateError = globalThis.AggregateError || AggregateError_
